import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import en from 'i18n/translations/en.json';
import es from 'i18n/translations/es.json';
import pt from 'i18n/translations/pt.json';

const resources = {
  ...en,
  ...pt,
  ...es,
};

i18n.use(initReactI18next).init({
  resources,
  lng: navigator.language || navigator.userLanguage,
  fallbackLng: 'en',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    format: function(value, format, lng) {
      if (format === 'uppercase')
        return value.toUpperCase();
      if (value instanceof moment)
        return value.format(format);
      return value;
    }
  },
});

export default i18n;
